import { Directive, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { NgStyleInterface } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import { UiTooltipTrigger } from "@webapp/ui/tooltip/tooltip.models";
import { UiTSType } from "@webapp/ui/core/models/ui-type.models";

@Directive({
  selector: "[ui-tooltip]",
  exportAs: "uiTooltip",
})
export class UiTooltipDirective extends NzTooltipDirective {
  @Input("uiTooltipTitle") public title?: UiTSType | null;
  @Input("uiTooltipTitleContext") public titleContext?: object | null = null;
  @Input("nz-tooltip") public directiveTitle?: UiTSType | null;
  @Input("uiTooltipTrigger") public trigger?: UiTooltipTrigger = "hover";
  @Input("uiTooltipPlacement") public placement?: string | string[] = "top";
  @Input("uiTooltipOrigin") public origin?: ElementRef<HTMLElement>;
  @Input("uiTooltipVisible") public visible = false;
  @Input("uiTooltipMouseEnterDelay") public mouseEnterDelay?: number;
  @Input("uiTooltipMouseLeaveDelay") public mouseLeaveDelay?: number;
  @Input("uiTooltipOverlayClassName") public overlayClassName?: string;
  @Input("uiTooltipOverlayStyle") public overlayStyle?: NgStyleInterface;
  @Input("uiTooltipArrowPointAtCenter") @InputBoolean() public arrowPointAtCenter?: boolean;
  @Input("uiTooltipColor") public nzTooltipColor?: string;

  @Output("uiTooltipVisibleChange") public readonly visibleChange = new EventEmitter<boolean>();
}
